import { render, staticRenderFns } from "./flowDialog.vue?vue&type=template&id=1363b2c7&scoped=true&"
import script from "./flowDialog.vue?vue&type=script&lang=js&"
export * from "./flowDialog.vue?vue&type=script&lang=js&"
import style0 from "./flowDialog.vue?vue&type=style&index=0&id=1363b2c7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1363b2c7",
  null
  
)

export default component.exports